import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HeroSection() {
  const top = articles[0];

  return (
    <section className="relative w-full overflow-hidden bg-background-100">
      <div
        className="absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-accent-100 blur-3xl opacity-70"
        aria-hidden="true"
      ></div>
      <div
        className="absolute -bottom-32 -left-20 w-[360px] h-[360px] rounded-full bg-secondary-100 blur-3xl opacity-60"
        aria-hidden="true"
      ></div>

      <div className="relative w-full px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="tx-rise">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5 text-xs text-primary-700">
              <i className="ri-restaurant-2-line text-sm" aria-hidden="true"></i>
              甜瓜田今日上新 12 条
            </span>
            <h1 className="mt-6 font-heading text-3xl md:text-5xl lg:text-[3.4rem] leading-[1.25] text-foreground-950">
              专磕甜向小瓜
              <br />
              每天给你一点<span className="text-primary-500">心动</span>
            </h1>
            <p className="mt-6 max-w-xl text-sm md:text-base leading-relaxed text-foreground-700">
              恋爱小料、心动瞬间、官宣现场与情侣小事一网打尽。想看点不扎心的糖，来这片甜瓜田翻翻新鲜软料，
              每一条都是能让人嘴角上扬的那种。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/fresh"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                进入瓜田速递
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
              <a
                href="#hot"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                看今日最甜
                <i className="ri-fire-line" aria-hidden="true"></i>
              </a>
            </div>

            <div className="mt-9 flex flex-wrap gap-x-8 gap-y-4">
              {[
                { k: '1,240+', v: '已整理甜味瓜' },
                { k: '98.6%', v: '甜度好评率' },
                { k: '每日 3 条', v: '精选推送' },
              ].map((s) => (
                <div key={s.v}>
                  <p className="font-heading text-xl text-foreground-950">{s.k}</p>
                  <p className="mt-1 text-xs text-foreground-500">{s.v}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative tx-rise">
            <div className="w-full h-[320px] md:h-[460px] overflow-hidden rounded-2xl bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Dreamy%20warm%20scene%20of%20two%20paper%20cups%20with%20heart%20shaped%20latte%20art%2C%20dried%20roses%20and%20a%20handwritten%20note%20on%20a%20cream%20linen%20table%2C%20soft%20coral%20and%20honey%20golden%20light%2C%20romantic%20editorial%20lifestyle%20photography%2C%20high%20detail&width=1200&height=1400&seq=txhero-main-01&orientation=portrait"
                alt="甜瓜田里的心动小物与手写便签"
                title="糖心吃瓜 - 甜瓜田心动小物"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <Link
              to={`/article/${top.slug}`}
              className="absolute -bottom-6 left-2 md:left-4 w-[86%] max-w-sm rounded-xl border border-background-200 bg-background-50 p-4 hover:border-primary-300 transition-colors cursor-pointer tx-float"
            >
              <p className="flex items-center gap-1.5 text-xs text-primary-600">
                <i className="ri-cup-line" aria-hidden="true"></i>
                今日最甜
              </p>
              <h3 className="mt-2 text-sm font-medium text-foreground-950 leading-snug line-clamp-2">
                {top.title}
              </h3>
              <span className="mt-2 inline-flex items-center gap-1 text-xs text-foreground-500">
                点开看看这口糖
                <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}